import { ApiResponse } from "../models/api-response";
import { callApi } from "./api.service";

const apiServerUrl = import.meta.env.VITE_API_SERVER_URL;

export interface Invoice {
  id: string;
  number: string | null;
  status: string | null;
  amount_paid: number;
  currency: string;
  created: string;
  hosted_invoice_url: string | null;
  invoice_pdf: string | null;
}

export const listInvoices = async (
  accessToken: string,
): Promise<ApiResponse<Invoice[]>> => {
  const config: RequestInit = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
  return callApi<Invoice[]>(`${apiServerUrl}/api/billing/invoices`, config);
};
